<template>
  <div v-if="shopData && activityInfo" class="shop-details-page">
    <div @click="back" class="back">返回</div>
    <LinkIFrame style="width: 100%; height: 100vh" :linkSrc="iframSrc" v-show="isOpenLink"></LinkIFrame>
    <div v-show="!isOpenLink" class="shop-details-container">
      <div class="banner"><img :src="shopData.bannerImage" alt="" /></div>
      <div class="details-card">
        <div class="name">{{ shopData.name }}</div>
        <div class="address">
          <div class="text">
            <p>{{ shopData.address.formattedAddress }}</p>
          </div>
          <!-- <div v-if="shopData.contactNumber && !shopData.nfhId" class="bar"></div> -->
          <div v-if="shopData.contactNumber" class="icon-phone" v-bind:class="{ iconPhoneSingle: !shopData.nfhId }" @click="phoneClick">
            <img src="../../assets/images/icon_phone.png" alt="" />
            <a :href="`tel:${shopData.contactNumber}`"></a>
          </div>
          <!-- 只有存在nfhId的时候才显示出来 -->
          <div v-if="shopData.nfhId" class="customerServerBtn" @click="openServerBtn"></div>
        </div>
        <div class="tag">
          <img v-for="item in shopData.labels" :key="item" :src="item" alt="" />
          <p
            style="
              margin-right: 0.2rem;
              background: #ffdba0;
              color: #7e2e15;
              font-size: 0.12rem;
              height: 100%;
              padding: 0 0.1rem;
              text-align: center;
              line-height: 0.32rem;
            "
          >
            {{
              activityInfo.categories.filter(info => info.uid == shopData.categoryId).length > 0 &&
              activityInfo.categories.filter(info => info.uid == shopData.categoryId)[0].name
                ? activityInfo.categories.filter(info => info.uid == shopData.categoryId)[0].name
                : null
            }}
          </p>
          <div class="distance">
            {{ shopData.distance > 1 ? `${shopData.distance.toFixed(1)}km` : shopData.distance*1000 &lt; 100 ? '&lt;100m' : `${(shopData.distance*1000).toFixed(1)}m` }}
          </div>
        </div>
      </div>
      <template v-for="(item, index) in activityInfo.modules">
        <div
          v-if="
            modulesMatchData &&
              modulesMatchData.filter(i => i.activityModuleId == item.uid).length > 0 &&
              (modulesMatchData.filter(i => i.activityModuleId == item.uid)[0].text ||
                modulesMatchData.filter(i => i.activityModuleId == item.uid)[0].images.length)
          "
          :key="item.uid + index"
          :data-uid="item.uid"
          class="info-card"
          :style="{ paddingBottom: item.shrink && item.IS_SHOW ? '0.5rem' : 0 }"
        >
          <div v-show="item.shrink && item.IS_SHOW" @click="more($event, index)" data-active="false" class="more">
            <p>展开查看</p>
            <img src="@/assets/images/icon_blue_more.png" alt="" />
          </div>
          <div class="title">
            <span class="bar"></span>
            <h1>{{ item.name }}</h1>
          </div>
          <div :ref="`modules${index}`" :style="{ maxHeight: item.shrink && item.IS_SHOW ? '400px' : 'none' }" class="html-insert">
            <div class="txt">
              <p
                @click="openLink"
                v-for="(txt, index) in modulesMatchData.filter(i => i.activityModuleId == item.uid)[0].text.split('\n')"
                :key="txt + index"
                v-html="matchNetUrl(txt)"
              ></p>
            </div>
            <div class="imgs">
              <img
                v-for="imgSrc in modulesMatchData.filter(i => i.activityModuleId == item.uid)[0].images"
                :key="imgSrc"
                :src="imgSrc"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
      <!-- <div class="shop-details">
        <div class="title">
          <span class="bar"></span>
          <h1>商家简介</h1>
        </div>
        <div class="html-insert"></div>
      </div>
      <div class="tips">
        <div class="title">
          <span class="bar"></span>
          <h1>小贴士</h1>
        </div>
        <div class="html-insert"></div>
      </div> -->
      <div class="nfplus">
        <div class="downLoad-box">
          <img class="download-img" :src="activityInfo.nfplusDownIcon" @click="downLoad" />
        </div>
        <!-- <div v-show="showDownLoad" class="downLoad-box">
          <img v-if="!deviceId" class="download-img" src="../../assets/images/download@2x.png" @click="downLoad" />
        </div> -->
      </div>
      <!-- 底部tool -->
      <Footer :footer="footer" class="detail-footer" :mainInfo="shopData" />
    </div>
    <div style="position: fixed; bottom: -5000px" class="map-container-fake"></div>
  </div>
</template>

<script>
import openApp from "@/utils/openApp.js"
import { getShopDetail, getActivityInfo } from "@/server/interfaces"
import LinkIFrame from "@/views/LinkIFrame/index.vue"
import { mapGetters, mapMutations, mapActions } from "vuex" //mapActions
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import { initShare } from "@/utils/share"
import { savePoint } from "@/utils/savePoint"
import Footer from "@/components/Footer"
import { buryingPoint } from "@/utils/buryingPoint"

export default {
  components: {
    LinkIFrame,
    Footer
  },
  data() {
    return {
      shopData: null,
      modulesMatchData: null,
      isOpenLink: false,
      iframSrc: "",
      activityInfo: null,
      map: null,
      userPosition: this.$route.params.userPosition ? this.$route.params.userPosition : null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true
      },
      footer: {}
    }
  },
  async created() {
    try {
      this.showLoading()
      if (this.userPosition) {
        await this.shareLinkIntoInit()
        this.hideLoading()
      } else {
        await this.getUserPosition()
      }
    } catch (e) {
      window.console.error(e)
    }
    buryingPoint({ action: 1, sourceTag: 5, activityId: this.activityId, itemType: 1, optionId: this.$route.query.shopId })
  },
  watch: {
    userPosition(newValue) {
      if (newValue) {
        this.hideLoading()
      }
    }
  },
  computed: {
    ...mapGetters({
      activityId: "activityInfo/activityId"
    }),
    modules() {
      return this.$refs.modules
    }
  },
  methods: {
    ...mapMutations({
      toast: "toast/showToast",
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      setShareInfo: "activityInfo/setShareInfo"
    }),
    ...mapActions({
      // initShareInfo: "activityInfo/initShareInfo"
      initNfPluseShare: "activityInfo/initNfPluseShare"
    }),
    phoneClick() {
      buryingPoint({ action: 31, sourceTag: 5, activityId: this.activityId, itemType: 1, optionId: this.$route.query.shopId })
    },
    async checkModulesHeight() {
      await this.$nextTick(() => {
        this.activityInfo.modules = this.activityInfo.modules.map((module, index) => {
          if (this.$refs[`modules${index}`] && this.$refs[`modules${index}`][0]) {
            let checkPoint = this.$refs[`modules${index}`][0].offsetHeight
            module.IS_SHOW = checkPoint > 400
          } else {
            module.IS_SHOW = ""
          }
          return module
        })
      })
    },
    more(event, index) {
      let target = event.currentTarget
      if (target.dataset.active == "true") {
        this.$refs[`modules${index}`][0].style.maxHeight = "5rem"
        target.firstChild.textContent = "展开查看"
        target.lastChild.setAttribute("style", "transform: rotate(0);")
        target.dataset.active = false
      } else if (target.dataset.active == "false") {
        this.$refs[`modules${index}`][0].style.maxHeight = "none"
        target.firstChild.textContent = "收起"
        target.lastChild.setAttribute("style", "transform: rotate(-180deg);")
        target.dataset.active = true
      }
    },
    openLink(e) {
      let target = e.target
      if (target.dataset.src) {
        this.iframSrc = target.dataset.src
        this.isOpenLink = true
      }
    },
    async openServerBtn() {
      const isInNFPlus = await window.nfplusJsbridge.getInsideVersion()
      if (isInNFPlus) {
        // 端内
        if (!window.nfplusJsbridge) {
          return
        }
        // 如果没有登陆，先让用户登陆
        let userInfos = await window.nfplusJsbridge.getUserInfo()
        if (userInfos && !userInfos.userId) {
          const _res = await window.nfplusJsbridge.nativeLogin()
          if (_res && _res.userUuid) {
            this.handleChatWithNfh()
          }
          return
        } else {
          this.handleChatWithNfh()
        }
      } else {
        // 端外
        this.handleOpenApp()
      }
    },
    // 端外打开APP方式
    handleOpenApp() {
      const address = `${window.location.origin}${window.location.pathname}?id=${this.shopData.activityId}`
      const Options = {
        id: this.shopData.nfhId,
        shareType: "nfh",
        title: document.title || "南方报业小记者",
        isActivity: false,
        isnfh: true,
        isRankList: false,
        needClipboard: true,
        openAppBigDataInfo: {
          url: window.location.href,
          origin: 3,
          sourceTag: 12,
          clickPosition: 30,
          itemId: this.shopData.nfhId,
          activityId: this.shopData.nfhId
        }
      }
      window.OpenApp(Options, process.env.VUE_APP_RUN_ENV)
    },
    // 端内调到私信的方法
    async handleChatWithNfh() {
      let _options = {
        entry: "1",
        sourceUuid: this.shopData.nfhId + "",
        sourceName: this.shopData.nfhName,
        showMore: "1"
      }
      const res = await window.nfplusJsbridge.chatWithNfh(_options)
    },
    matchNetUrl(txt) {
      return txt.replace(
        /((http|ftp|https|file):\/\/([\w-]+\.)+[\w-]+(\/[\w\u4e00-\u9fa5\-./?@%!&=+~:#;,]*)?)/gi,
        `<a style="font-family: PingFangSC-Regular;font-size: 0.28rem;color: #2D75E2;letter-spacing: 0;" class="link" data-src="$1">$1</a>`
      )
    },
    async getDeviceId() {
      let id = await window.nfplusJsbridge.getDeviceId()
      this.deviceId = id
    },
    getUserPosition() {
      /* global AMap */
      this.map = new AMap.Map("map-container-fake", {
        center: [113.325, 23.137]
      })
      this.map.plugin("AMap.Geolocation", () => {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, "complete", this.onComplete) // 返回定位信息
        AMap.event.addListener(geolocation, "error", this.onError) // 返回定位出错信息
      })
    },
    onComplete(obj) {
      var res =
        "经纬度：" +
        obj.position +
        "\n精度范围：" +
        obj.accuracy +
        "米\n定位结果的来源：" +
        obj.location_type +
        "\n状态信息：" +
        obj.info +
        "\n地址：" +
        obj.formattedAddress +
        "\n地址信息：" +
        JSON.stringify(obj.addressComponent, null, 4)
      window.console.log(res)
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true
      }
      this.shareLinkIntoInit()
    },
    onError(obj) {
      window.console.log(obj)
      this.shareLinkIntoInit()
    },
    back() {
      if (this.isOpenLink) {
        this.isOpenLink = false
      } else {
        this.$router.replace("/")
      }
    },
    downLoad() {
      // 增加引流下载统计
      openApp({
        address: window.location.href,
        clickPosition: 30
      })
    },
    async shareLinkIntoInit() {
      try {
        let detailRes = await getActivityInfo({
          params: {
            id: this.activityId
          }
        })
        if (detailRes) {
          this.activityInfo = detailRes
          await this.getShopDetail()
          await this.checkModulesHeight()
        } else {
          this.toast("活动信息获取失败")
          this.$router.replace("/nothingnessActivity")
        }
      } catch (e) {
        this.toast("活动信息获取失败")
        this.$router.replace("/nothingnessActivity")
      }
    },
    async getShopDetail() {
      if (!this.userPosition) {
        this.userPosition = this.defaultPosition
      }
      let data = {
        params: {
          coordinates: this.userPosition,
          id: this.$route.query.shopId
        }
      }
      let res = await getShopDetail(data)
      this.modulesMatchData = res.modules
      this.shopData = res
      this.footer = {
        locationSignIn: res.locationSignIn
      }
      savePoint({
        deviceid: window.localStorage.getItem("nfplus_deviceid"),
        dataType: "1000099",
        actionTime: Date.parse(new Date()),
        url: location.href || "",
        refer: document.referrer || "",
        origin: "9", // 9 - 信息地图H5
        action: "29", // 访问详情页
        optionId: res.id, //商家ID
        optionName: res.name, //商家名字
        activityId: res.activityId //活动ID
      })
      setDocuemntTtitle(this.shopData.name)
      this.setShareInfo({
        title: res.name,
        desc: this.activityInfo.share.shareDesc,
        link: window.location.href,
        imgUrl: res.mainImage
      })
      try {
        await this.initNfPluseShare()
      } catch (e) {
        window.console.log(e)
      }
      try {
        await initShare({
          shareTitle: res.name,
          shareUrl: window.location.href,
          shareIcon: res.mainImage,
          shareDesc: this.activityInfo.share.shareDesc
        })
      } catch (e) {
        window.console.log(e)
      }

      // this.setShareInfo({
      //   title: res.name,
      //   desc: this.activityInfo.share.shareDesc,
      //   link: window.location.href,
      //   imgUrl: res.mainImage
      // })
      // this.initShareInfo()
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.shop-details-page {
  .back {
    width: 0.95rem;
    height: 0.66rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0 38px 38px 0;
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 9999;
    transform: translate(0, -50%);
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
  }
  .shop-details-container {
    background: #f5f4f4;
    .banner {
      width: 7.5rem;
      height: 4.22rem;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .details-card {
      background: #fff;
      padding: 0.4rem 0.3rem 0.3rem 0.2rem;
      margin-bottom: 0.2rem;
      .name {
        font-size: 0.34rem;
        color: #333333;
        margin-bottom: 0.1rem;
      }
      .tag {
        display: flex;
        flex-flow: row nowrap;
        position: relative;
        img {
          display: block;
          width: 0.64rem;
          height: 0.32rem;
          margin-right: 0.2rem;
        }
        .distance {
          font-size: 0.26rem;
          color: #333333;
        }
      }
      .address {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.2rem;
        position: relative;
        .text {
          font-size: 0.26rem;
          color: #666666;
          max-width: 5.45rem;
        }
        .customerServerBtn {
          width: 0.7rem;
          height: 0.6rem;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          background: url(../../assets/images/icon_message.png) no-repeat center right;
          background-size: 0.4rem;
          border-left: 1px solid #ddd;
        }
        .bar {
          width: 0.01rem;
          height: 0.6rem;
          border: 1px solid #dddddd;
        }
        .icon-phone {
          position: absolute;
          width: 0.4rem;
          height: 0.4rem;
          right: 0.95rem;
          top: 50%;
          transform: translate(0, -50%);
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 0.4rem;
            height: 0.4rem;
          }
          a {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 0.4rem;
            height: 0.4rem;
            opacity: 0;
            z-index: 10;
          }
        }
        .iconPhoneSingle {
          width: 0.9rem !important;
          height: 0.6rem !important;
          right: 0 !important;
          border-left: 1px solid #ddd;
        }
      }
    }

    .title {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      padding-top: 0.1rem;
      .bar {
        display: block;
        width: 0.1rem;
        height: 0.3rem;
        background: #f36232;
        margin-right: 0.1rem;
      }
      h1 {
        color: #333333;
        font-size: 0.34rem;
        line-height: 0.6rem;
      }
    }

    .info-card {
      background: #fff;
      margin-bottom: 0.2rem;
      padding-bottom: 0.5rem;
      position: relative;
      .more {
        position: absolute;
        left: 50%;
        bottom: 0.15rem;
        transform: translate(-50%, 0);
        font-size: 0.26rem;
        color: #3b7fe4;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        line-height: 0.26rem;
        img {
          display: block;
          width: 0.24rem;
          margin-left: 0.1rem;
          transition: all 0.5s;
        }
      }
      .html-insert {
        padding: 0 0.2rem;
        width: 100%;
        overflow: hidden;
        margin-bottom: 0.2rem;
        .txt {
          p {
            width: 100%;
            font-family: PingFangSC-Regular;
            font-size: 0.29rem;
            line-height: 0.43rem;
            color: #666666;
            letter-spacing: 0;
            margin-bottom: 0.2rem;
            word-break: break-word;
          }
        }
        .imgs {
          display: flex;
          flex-flow: column nowrap;
          align-items: center;
          justify-content: center;
          max-width: 100%;
          img {
            margin-bottom: 0.2rem;
            display: block;
            max-width: 100%;
          }
        }
      }
    }

    .shop-details {
      background: #fff;
      margin-bottom: 0.2rem;
    }

    .tips {
      background: #fff;
      margin-bottom: 0.2rem;
    }

    .nfplus {
      .downLoad-box {
        width: 100%;
        height: 72px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
        align-items: center;
        .download-img {
          display: block;
          width: 188px;
          height: 44px;
        }
      }
    }
    .detail-footer {
      height: 1.37rem;
      overflow: hidden;
      width: 100%;
      border-top: 1px solid #eee;
      padding: 0 0.4rem;
      z-index: 3;
      position: fixed;
      bottom: 0;
      justify-content: space-around;
    }
  }
}
</style>
